import { Component, OnInit, Input } from '@angular/core';
import { InvoiceService } from '../../invoices/invoice.service';
import { PopoverController } from '@ionic/angular';
import { DialogService } from '../../_services';
import { StringConstants } from '../../_constants/stringConstants';

@Component({
  selector: 'outstanding-inv-details',
  templateUrl: './outstanding-inv-details.component.html',
})
export class OutstandingInvDetailsComponent implements OnInit {
  @Input() distributorData: any = {};
  @Input() divisionWiseData: any = [];
  constructor(
    private invoiceService: InvoiceService,
    private modal: PopoverController,
    private dialogService: DialogService
  ) { }
  ngOnInit() {
    this.init();
  }

  init() {
    this.getDetailsForAllDivision();
  }

  getDetailsForAllDivision() {
    this.divisionWiseData.forEach(div => {
      this.getDivisionData(div);
    })
  }

  dismiss() {
    this.modal.dismiss();
  }

  getDivisionData(div) {
    this.invoiceService.getDivisionWiseOutstandingInfo(this.distributorData, div.clickSection, div.TYPE).subscribe(data => {
      data.forEach(item => {
        div.details.push(item);
      })
    });
  }

  close() {
    
  }

}
